import React from "react";
import { Link } from "react-router-dom";
import { formatDistanceToNow } from "date-fns";


const TeacherCard = ({ teacher }) => {
  return (
    <Link
      to={`/teachers/${teacher._id}`}
      className="bg-white shadow hover:shadow-lg transition duration-200 rounded-lg p-6 flex flex-col items-center text-center"
    >
      <img
        src={teacher.avatar}
        alt={teacher.name}
        className="w-28 h-28 rounded-full object-cover border-2 border-indigo-500"
      />

      <h2 className="text-lg font-semibold text-gray-800 mt-4">{teacher.name}</h2>

      {teacher.bio && teacher.bio.trim() !== "" && (
        <p className="text-sm text-gray-500 mt-1">{teacher.bio}</p>
      )}

      <p className="text-sm text-yellow-600 font-medium mt-2">⭐ {teacher.rating.toFixed(1)} / 5</p>

      <p className="text-sm text-gray-600 mt-1">
        {teacher.offeredCourses?.length || 0} course{teacher.offeredCourses?.length === 1 ? "" : "s"} offered
      </p>
       {teacher.createdAt && (
        <p className="text-xs text-gray-400 mt-2">
          Joined {formatDistanceToNow(new Date(teacher.createdAt), { addSuffix: true })}
        </p>
      )}
    </Link>
  );
};

export default TeacherCard;
